import { joinPath } from "../api/client";

const MAX_LOGO_BYTES = 5 * 1024 * 1024;

function readAsDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error("Could not read image file"));
    reader.readAsDataURL(file);
  });
}

/**
 * Upload organization logo during public signup (no auth token required).
 * Falls back to an inline data URL when S3 is not configured (local dev).
 */
export async function uploadTenantLogo(file) {
  if (!file) return "";
  if (file.size > MAX_LOGO_BYTES) {
    throw new Error("Logo must be 5 MB or smaller");
  }

  const formData = new FormData();
  formData.append("files", file);

  const res = await fetch(joinPath("v2/auth/signup/logo"), {
    method: "POST",
    body: formData,
  });
  const data = await res.json().catch(() => ({}));
  const url = data?.data?.urls?.[0];

  if (res.ok && url) return url;

  const message = data?.message || "Logo upload failed";
  if (res.status === 503 || /not configured/i.test(message)) {
    return readAsDataUrl(file);
  }

  throw new Error(message);
}
